import { render, staticRenderFns } from "./invoices-table.vue?vue&type=template&id=6f3f875a&"
import script from "./invoices-table.vue?vue&type=script&lang=js&"
export * from "./invoices-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports